import { defineMachine } from "../state-machine.js";
/** Enterprise verification (docs/02-domain.md, "Enterprise verification and seller enablement"). */
export const enterpriseVerification = defineMachine({
    name: "enterprise-verification",
    states: ["submitted", "under_review", "verified", "rejected", "suspended", "closed"],
    events: ["start_review", "approve", "reject", "resubmit", "suspend", "reinstate", "close"],
    initial: "submitted",
    transitions: {
        submitted: { start_review: "under_review", close: "closed" },
        under_review: { approve: "verified", reject: "rejected" },
        verified: { suspend: "suspended", close: "closed" },
        rejected: { resubmit: "submitted", close: "closed" },
        suspended: { reinstate: "verified", close: "closed" },
        closed: {},
    },
});
/** Selling needs an opened shop and an Airwallex KYB approval that arrives only by webhook. */
export const sellerEnablement = defineMachine({
    name: "seller-enablement",
    states: ["no_shop", "shop_opened", "kyb_pending", "can_sell", "kyb_rejected"],
    events: ["open_shop", "start_kyb", "kyb_approved", "kyb_rejected", "resubmit_kyb", "kyb_revoked"],
    initial: "no_shop",
    transitions: {
        no_shop: { open_shop: "shop_opened" },
        shop_opened: { start_kyb: "kyb_pending" },
        kyb_pending: { kyb_approved: "can_sell", kyb_rejected: "kyb_rejected" },
        kyb_rejected: { resubmit_kyb: "kyb_pending" },
        can_sell: { kyb_revoked: "kyb_rejected" },
    },
});
//# sourceMappingURL=verification.machine.js.map